(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/competition.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/competition.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.Competition = Backbone.Model.extend({
    log: new svs.core.log.Logger('svs.models.Competition'),
    defaults: {
      isInCompetitionMode: false,
      competitionSystem: undefined,
      competitionId: undefined,
      competitionUrl: ''
    },

    initialize: function() {
      this.setData();

      this.listenTo(
        svs.competition.Helper.userCompetitions,
        'sync',
        this.setUserCompetitionData
      );
      this.listenTo(
        svs.competition.Helper.participatedDraws,
        'sync',
        this.setUserHasPlayedCurrentRound
      );
    },

    setData: function() {
      var currentDrawNumber = svs.tipset.collections.draws
          .getCurrentDraw()
          .get('drawNumber'),
        system = {
          type: 'SM',
          full: 0,
          half: 6,
          rows: 64,
          mg: 0,
          systemNum: 1
        };

      if (svs.competition.core.data.tipsSMCompetition) {
        svs.competition.core.data.tipsSMCompetition.tipsSMDetails.currentDraw = svs.tipset.collections.draws
          .getCurrentDraw()
          .get('drawNumber');
      }
      this.setCompetitionSignUpMode();
      this.setUserHasPlayedCurrentRound();
      this.setUserIsParticipatingInTipsSM();
      this.setCompetitionUrl();
      this.setIsInCompetitionMode(window.location.href.indexOf('tipssm') > -1);
      this.set(
        {
          competitionSystem: system,
          competitionId: svs.competition.core.data.tipsSMCompetition
            ? svs.competition.core.data.tipsSMCompetition.id
            : '',
          drawIsValidForTipsSM: svs.competition.Helper.drawIsValidForTipsSM(
            currentDrawNumber
          ),
          isPaying: false
        },
        { silent: true }
      );
    },

    setCompetitionUrl: function() {
      var competitionUrl = '';
      if (
        svs.tipset.data.competition &&
        svs.tipset.data.competition.clientUrl
      ) {
        competitionUrl = svs.tipset.data.competition.clientUrl + '/';
      }
      this.set('competitionUrl', competitionUrl, { silent: true });
    },

    setIsInCompetitionMode: function(isInCompetitionMode) {
      this.set('isInCompetitionMode', isInCompetitionMode, { silent: true });
    },

    getCompetitionMode: function() {
      return this.get('isInCompetitionMode');
    },

    getCompetitionSystem: function() {
      return this.get('competitionSystem');
    },

    getCompetitionId: function() {
      return this.get('competitionId');
    },

    getCompDesc: function() {
      return svs.competition.core.makeup(this.get('compDesc'));
    },

    setCompetitionSignUpMode: function() {
      var isCompetitionSignUpMode =
        svs.competition.core.data.canRegisterForTipsSM &&
        !svs.competition.Helper.userIsParticipatingInTipsSM();
      this.set('isCompetitionSignUpMode', isCompetitionSignUpMode, {
        silent: true
      });
    },

    getCompetitionSignUpMode: function() {
      return this.get('isCompetitionSignUpMode');
    },

    setUserCompetitionData: function() {
      this.setCompetitionSignUpMode();
      this.setUserHasPlayedCurrentRound();
      this.setUserIsParticipatingInTipsSM();
    },

    setUserHasPlayedCurrentRound: function() {
      this.set(
        'userHasPlayedCurrentRound',
        svs.competition.Helper.userHasPlayedCurrentDraw()
      );
    },

    getUserHasPlayedCurrentRound: function() {
      return this.get('userHasPlayedCurrentRound');
    },

    canPlayTipsSM: function() {
      return (
        !this.getUserHasPlayedCurrentRound() &&
        (this.getCompetitionSignUpMode() ||
          this.getCompetitionMode() ||
          this.getUserIsParticipatingInTipsSM())
      );
    },

    getDrawIsValidForTipsSM: function() {
      return this.get('drawIsValidForTipsSM');
    },

    getUserIsParticipatingInTipsSM: function() {
      return this.get('userIsParticipationgInTipsSM');
    },

    setUserIsParticipatingInTipsSM: function() {
      this.set(
        'userIsParticipationgInTipsSM',
        svs.competition.Helper.userIsParticipatingInTipsSM(),
        { silent: true }
      );
    },

    setIsPayingCompetition: function(isPaying) {
      this.set('isPayingCompetition', isPaying || false, { silent: true });
    },

    getIsPayingCompetition: function() {
      return this.get('isPayingCompetition');
    },

    reset: function() {
      this.setData();
    },

    getCompetitionUrl: function() {
      return this.get('competitionUrl');
    }
  });
})(Backbone, _, svs);

 })(window);